"use client"

import { FormattedMessage } from "react-intl"

import {
  UserMessageChannelData,
  useUserContext,
} from "@bullseye/components"
import { MessageChannel } from "@bullseye/types"

import { AcceptMessagePrompt } from "./AcceptMessagePrompt"
import { NoReplyMessage } from "./NoReplyMessage"

type Props = {
  messageChannel?: MessageChannel
  userMessageChannel?: UserMessageChannelData
  isBlockedByUser?: boolean
  isBlockedLoading?: boolean
  handleAcceptMessage: () => void
  InputComponent: React.ComponentType<{ grow?: boolean }>
}

export const MessengerInput = ({
  messageChannel,
  userMessageChannel,
  isBlockedByUser,
  isBlockedLoading = false,
  handleAcceptMessage,
  InputComponent,
}: Props) => {
  const { user } = useUserContext()

  const isHankAdminUser =
    messageChannel?.creator_id === "a17d77d8-aa6a-4559-9a3a-d19bf872f185" ||
    messageChannel?.creator?.stream_id === "hello-gethank-com"

  const userIsSuspended = messageChannel?.dm_user?.is_suspended || false

  if (isHankAdminUser) {
    return (
      <NoReplyMessage
        message={<FormattedMessage id="messenger.hankUser.noReply" />}
      />
    )
  }

  if (userIsSuspended) {
    return (
      <NoReplyMessage
        message={<FormattedMessage id="messenger.suspendedUser.noReply" />}
      />
    )
  }

  if (!messageChannel || !userMessageChannel) return null

  if (!messageChannel.is_group_message && isBlockedLoading) {
    return null
  }

  if (
    !messageChannel.is_group_message &&
    typeof isBlockedByUser === "boolean" &&
    isBlockedByUser
  ) {
    return (
      <NoReplyMessage
        message={"This member isn't accepting messages from you."}
      />
    )
  }

  if (!messageChannel.is_group_message && !userMessageChannel.is_accepted && user.id !== userMessageChannel.message_channel.creator_id) {
    return (
      <AcceptMessagePrompt
        messageChannel={messageChannel}
        userMessageChannel={userMessageChannel}
        handleAcceptMessage={handleAcceptMessage}
      />
    )
  }

  return <InputComponent grow />
}